export const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

export const setCookie = (cname, cvalue, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export const resetCookie = () => {
  setCookie('maac-main','TimeZoneOffset=4&LastActivity=09/27/2023 11:22:46&ViewedCityIds=9511f2e3-9ace-45a4-9a76-6b105567a228&ViewedPropertyIds=611790','30');
}



// WEBPACK FOOTER //
// ./src/js/components/cookie-functions.js